import React, {useState} from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import OptionGroup from "../components/OptionGroup";

const Detail = (props) => {

    const [size, setSize] = useState("L");
    const [color, setColor] = useState("red");

    const sizeOptions = [
        { label: "M", value: "M" },
        { label: "S", value: "S" },
        { label: "L", value: "L" },
    ];

    const colorOptions = [
        { label: "Red", value: "red" },
        { label: "Black", value: "black" },
    ];

    return (
        <>
            <Header />
            <div className="container" id="product-detail">
                <div className="row mt-5">
                    <div className="col-12 col-md-6">
                        <img className="img-fluid mb-2" src="assets/images/sample-1.jpg" alt="gym-women" />
                    </div>

                    <div className="col-12 col-md-6 mt-3">
                        <div className="mb-5">
                            <h3>Block Zipper Hoodie</h3>
                            <h5>ZMW89.00</h5>
                        </div>

                        <OptionGroup
                            label="Size"
                            options={sizeOptions}
                            value={size}
                            onChange={setSize}
                            />

                        <OptionGroup
                            label="Color"
                            options={colorOptions}
                            value={color}
                            onChange={setColor}
                        />

                        <div>
                            <h6>Description</h6>
                            <p>Cozy up in the Block Zipper Hoodie. Featuring a smooth zip closure and ultra-soft fabric, this hoodie is designed for laid-back days and chill vibes.</p>
                        </div>

                        <button className="btn btn-primary btn-cart btn-block">ADD TO CART</button>
                    </div>
                </div>
            </div>

            <div className="container mb-5" id="product">
                <div className="mb-4">
                    <hr/>
                    <h5 id="tx-shop">MORE PRODUCTS</h5>
                </div>
                <div className="row">
                    <div className="col-12 col-md-3" onClick={() => props.history.push('/product-detail/12345')}>
                        <img className="img-fluid mb-2" src="assets/images/sample-2.jpg" alt="" />
                        <h4>Slim Fit Baseball Jacket</h4>
                        <p>ZMW169.00</p>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Detail;
